// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основний контейнер */
.r8zy9Yw94bEmqqDjEQiD {
  display: flex;
  flex-direction: column;
}

.C1lQ1kQZsYUFrK_8Wwxg {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}

/* Обгортка для колонок */
.JGf8MGPeHfOLgaiVxZOZ {
  display: flex;
  margin-top: 20px;
  background-color: var(--disabled-bg);
  border-radius: 20px;
  padding: 10px;
  min-height: 400px;
}

/* Ліва частина (список) */
.t3f4CAa5_bZSYlVLyGsg {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  width: 50%;
  padding-right: 8px;
  overflow-y: auto;
  max-height: 400px;
}

/* Права частина (редактор) */
.UywhlR8Q12VbNyLM3ZW9 {
  padding: 10px;
  flex: 1;
  background-color: var(--white);
  border-radius: 20px;
  width: 50%;
}

.Dq9muujTlEEXktZaCnny {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  
}

/* Активний текст */
.hyYf_jo4cDS_YUExXV4D {
  color: var(--blue);
  font-weight: 700;
}

/* Футер з кнопками */
.gBM_EhEkhtk1_NxqkTUS {
  display: flex;
  gap: 10px;
  margin: 20px 0;
}

.xed5z2SwniqDHDXlPYxr {
  flex: 1;
  text-decoration: underline dotted;
  text-underline-offset: 3px;
  text-decoration-color: rgba(0, 102, 255, 0.5);
  background: none;
  border: none;
  color: var(--blue);
  cursor: pointer;
  font-size: 14px;
}

/* ————— Адаптивність ————— */

@media (max-width: 768px) {
  .JGf8MGPeHfOLgaiVxZOZ {
    flex-direction: column;
    min-height: auto;
    max-height: 70vh;
    overflow-y: auto;
      margin-top: 10px;

  }


  .t3f4CAa5_bZSYlVLyGsg {
    width: 100%;
    max-height: 200px;
    border-bottom: 1px solid var(--border-color);
    padding-bottom: 10px;
    padding-right: 0;
  }

  .UywhlR8Q12VbNyLM3ZW9 {
    width: 100%;
    margin-top: 10px;
        padding-top: 20px;

  }

  .gBM_EhEkhtk1_NxqkTUS {
    flex-direction: column;
    gap: 12px;
  }

  .xed5z2SwniqDHDXlPYxr {
    order: 2;
    padding: 10px;
  }
  .gBM_EhEkhtk1_NxqkTUS {
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin: 0;
    margin-top: 10px;
  }

  /* Звертаємося до компонента Btn всередині футера */
  .gBM_EhEkhtk1_NxqkTUS button, 
  .gBM_EhEkhtk1_NxqkTUS .xed5z2SwniqDHDXlPYxr {
    width: 100% !important; /* Ігноруємо пропс \$width="20px" або подібні */
    min-height: 47px;       /* Гарантуємо зручний розмір для натискання */
    flex: none;             /* Вимикаємо flex: 1, щоб кнопка не стискалася */
  }
}

.JQDhxqZgriFbctEmB1gg {
  max-height: 90dvh;
  height: max-content;
  min-width: 480px;
  overflow: hidden;
}

@media (max-width: 768px) {
  .JQDhxqZgriFbctEmB1gg {
    /* Ширина 90% для мобільних пристроїв */
    min-width: 90%;
    /* Додатково можна відцентрувати або змінити відступи, якщо потрібно */
    margin: 0 auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Attr.module.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,OAAO;EACP,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;;AAEd;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,iCAAiC;EACjC,0BAA0B;EAC1B,6CAA6C;EAC7C,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,6BAA6B;;AAE7B;EACE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;MACd,gBAAgB;;EAEpB;;;EAGA;IACE,WAAW;IACX,iBAAiB;IACjB,4CAA4C;IAC5C,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;QACZ,iBAAiB;;EAEvB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,QAAQ;IACR,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,SAAS;IACT,gBAAgB;EAClB;;EAEA,mDAAmD;EACnD;;IAEE,sBAAsB,EAAE,8CAA8C;IACtE,gBAAgB,QAAQ,6CAA6C;IACrE,UAAU,cAAc,gDAAgD;EAC1E;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,uCAAuC;IACvC,cAAc;IACd,sEAAsE;IACtE,cAAc;EAChB;AACF","sourcesContent":["/* Основний контейнер */\n.addAttributesDocPopup_container {\n  display: flex;\n  flex-direction: column;\n}\n\n.addAttributesDocPopup_title {\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n/* Обгортка для колонок */\n.addAttributesDocPopup_contentWrapper {\n  display: flex;\n  margin-top: 20px;\n  background-color: var(--disabled-bg);\n  border-radius: 20px;\n  padding: 10px;\n  min-height: 400px;\n}\n\n/* Ліва частина (список) */\n.addAttributesDocPopup_sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  width: 50%;\n  padding-right: 8px;\n  overflow-y: auto;\n  max-height: 400px;\n}\n\n/* Права частина (редактор) */\n.addAttributesDocPopup_mainContent {\n  padding: 10px;\n  flex: 1;\n  background-color: var(--white);\n  border-radius: 20px;\n  width: 50%;\n}\n\n.addAttributesDocPopup_factoryInner {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  \n}\n\n/* Активний текст */\n.addAttributesDocPopup_activeText {\n  color: var(--blue);\n  font-weight: 700;\n}\n\n/* Футер з кнопками */\n.addAttributesDocPopup_footer {\n  display: flex;\n  gap: 10px;\n  margin: 20px 0;\n}\n\n.addAttributesDocPopup_btnCancel {\n  flex: 1;\n  text-decoration: underline dotted;\n  text-underline-offset: 3px;\n  text-decoration-color: rgba(0, 102, 255, 0.5);\n  background: none;\n  border: none;\n  color: var(--blue);\n  cursor: pointer;\n  font-size: 14px;\n}\n\n/* ————— Адаптивність ————— */\n\n@media (max-width: 768px) {\n  .addAttributesDocPopup_contentWrapper {\n    flex-direction: column;\n    min-height: auto;\n    max-height: 70vh;\n    overflow-y: auto;\n      margin-top: 10px;\n\n  }\n\n\n  .addAttributesDocPopup_sidebar {\n    width: 100%;\n    max-height: 200px;\n    border-bottom: 1px solid var(--border-color);\n    padding-bottom: 10px;\n    padding-right: 0;\n  }\n\n  .addAttributesDocPopup_mainContent {\n    width: 100%;\n    margin-top: 10px;\n        padding-top: 20px;\n\n  }\n\n  .addAttributesDocPopup_footer {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .addAttributesDocPopup_btnCancel {\n    order: 2;\n    padding: 10px;\n  }\n  .addAttributesDocPopup_footer {\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n    margin: 0;\n    margin-top: 10px;\n  }\n\n  /* Звертаємося до компонента Btn всередині футера */\n  .addAttributesDocPopup_footer button, \n  .addAttributesDocPopup_footer .addAttributesDocPopup_btnCancel {\n    width: 100% !important; /* Ігноруємо пропс $width=\"20px\" або подібні */\n    min-height: 47px;       /* Гарантуємо зручний розмір для натискання */\n    flex: none;             /* Вимикаємо flex: 1, щоб кнопка не стискалася */\n  }\n}\n\n.addAttributesDocPopup_modal {\n  max-height: 90dvh;\n  height: max-content;\n  min-width: 480px;\n  overflow: hidden;\n}\n\n@media (max-width: 768px) {\n  .addAttributesDocPopup_modal {\n    /* Ширина 90% для мобільних пристроїв */\n    min-width: 90%;\n    /* Додатково можна відцентрувати або змінити відступи, якщо потрібно */\n    margin: 0 auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addAttributesDocPopup_container": `r8zy9Yw94bEmqqDjEQiD`,
	"addAttributesDocPopup_title": `C1lQ1kQZsYUFrK_8Wwxg`,
	"addAttributesDocPopup_contentWrapper": `JGf8MGPeHfOLgaiVxZOZ`,
	"addAttributesDocPopup_sidebar": `t3f4CAa5_bZSYlVLyGsg`,
	"addAttributesDocPopup_mainContent": `UywhlR8Q12VbNyLM3ZW9`,
	"addAttributesDocPopup_factoryInner": `Dq9muujTlEEXktZaCnny`,
	"addAttributesDocPopup_activeText": `hyYf_jo4cDS_YUExXV4D`,
	"addAttributesDocPopup_footer": `gBM_EhEkhtk1_NxqkTUS`,
	"addAttributesDocPopup_btnCancel": `xed5z2SwniqDHDXlPYxr`,
	"addAttributesDocPopup_modal": `JQDhxqZgriFbctEmB1gg`
};
export default ___CSS_LOADER_EXPORT___;
